import { Switch } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
import { call } from '@/lib/api';
import { queryClient } from '@/lib/query';
import { apiErrorText } from '@/models/clientCompanies';
import { useHasAnyPermission } from '@/models/permissions';
import { keys } from '@/models/services';

export function RegistersCompanySwitch({
  serviceId,
  value,
}: {
  serviceId: number;
  value: boolean | undefined;
}) {
  const canWrite = useHasAnyPermission(['services:write', 'services:*', '*:*']);
  const save = useMutation({
    mutationFn: (registersCompany: boolean) =>
      call('service/registers-company', {
        json: { id: serviceId, registersCompany },
      }).catch((e) => {
        Object.assign(e, { handled: true });
        throw e;
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: keys.all }),
    onError: (e) =>
      notifications.show({
        color: 'red',
        title: 'Flag not saved',
        message: apiErrorText(e),
      }),
  });

  return (
    <Switch
      size="xs"
      label="Registers a company"
      description="When this service is sold, Settle creates a new client company in registration"
      checked={!!value}
      disabled={value === undefined || !canWrite || save.isPending}
      onChange={(e) => save.mutate(e.currentTarget.checked)}
    />
  );
}
